/**
 * ProjectSettings Component
 */

import { getOriginLocation } from '../../../utils/router';
import { shareProject, submitForm } from './form';
import './project-settings.scss';

import { isEqual } from 'lodash';
import * as nextTick from 'next-tick';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

import Button from '../../atoms/buttons/Button';

import { IconUserAdd } from '../../atoms/images/Icon';
import { Span } from '../../atoms/text/Label';
import TextField from '../../molecules/forms/TextFieldWithLabel';
import { SharedProjectPagePath } from '../SharedProject';

interface IOwnStateProps {
  userProfile: GQL.IProfile | undefined;
}

interface IOwnProps {
  license: ILicenseUsage[];
  open: boolean;
  project: GQL.IProject;
  submitting: boolean;
  onRequestClose?(): void;
  onSaveLicense(usages: ILicenseUsage[]): void;
}

type ProjectSettingsProps = IOwnStateProps & IOwnProps & IDispatchProps;

const classes = new BEM('project-settings');

class ProjectSettings extends React.Component<ProjectSettingsProps, {}> {

  shouldComponentUpdate(nextProps: ProjectSettingsProps) {
    return nextProps.project.id !== this.props.project.id
      || !isEqual(nextProps.license, this.props.license)
      || nextProps.open !== this.props.open
      || nextProps.submitting !== this.props.submitting;
  }

  onRenameProject = () => {
    this.props.dispatch(submitForm());
  }

  onShareProject = () => {
    this.props.dispatch(shareProject());
    nextTick(() => {
      this.props.dispatch(submitForm());
    });
  }

  renderCollaborator = ({
    first_name,
    last_name,
    role,
    user_id,
  }) => {
    const collaboratorIsUser = this.props.userProfile && this.props.userProfile.user_id === user_id;
    const name = first_name && last_name ? `${first_name} ${last_name}` : 'Unregistred user';
    return (
      <li key={user_id} {...classes('collaborator-list__item')}>
        <Span variant="description" size="large" textColor="bw7">
          {collaboratorIsUser ? 'You' : name}
        </Span>
        {role === 'owner' && <Span size="small">Owner</Span>}
      </li>
    );
  }

  render() {
    const {
      open,
      project: {
        is_public,
        opaque_id,
        users,
      },
      submitting,
    } = this.props;

    return (
      <div {...classes('', { open })}>
        <div {...classes('section')}>
          <Field
            name="activeProject.name"
            component={TextField}
            label="Rename Playlist"
            colorScheme="white"
            size="medium"
            inlineButton={<Button label="Save" onClick={this.onRenameProject} colorScheme="dark" />}
            disabled={submitting}
          />
        </div>

        <div {...classes('section')}>
          <Field
            component="input"
            type="hidden"
            name="activeProject.isPublic"
            disabled={submitting}
          />
          {is_public ? (
            <TextField
              name="activeProject.sharingUrl"
              label="Playlist Sharing URL"
              colorScheme="white"
              value={`${getOriginLocation()}${SharedProjectPagePath(opaque_id!)}`}
              isControlled
              readOnly
            />
          ) : (
            <Button
              onClick={this.onShareProject}
              label="Share Playlist"
              colorScheme="accent2"
              size="small"
              variant="pill"
              icon={<IconUserAdd />}
              disabled={submitting}
              withShadow
              {...classes('share-project-button')}
            />
          )}
        </div>
        {is_public && users && users.length > 1 && (
          <div {...classes('section')}>
            <Span size="small">Collaborators</Span>
            <ul {...classes('collaborator-list')}>
              {users!.map(this.renderCollaborator)}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

const ConnectedProjectSettings = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  ({ user: { profile: userProfile } }) => ({ userProfile }),
)(ProjectSettings);

export default ConnectedProjectSettings;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Projects/ProjectSettings.tsx